const emailLinks = document.querySelectorAll('.email-link')
if (emailLinks && emailLinks.length > 0) {
  emailLinks.forEach((emailLink) => {
    const email = emailLink.getAttribute('data-name') + '@' + emailLink.getAttribute('data-domain')
    emailLink.innerHTML = '<a href="mailto:' + email + '">' + email + '</a>'
  })
}
